import { debug, i18n, inject, observable, observer, pr, React, RouteComponentProps, ui } from "aaa";
import { pushRoute } from "stores/RouterFunctions";
import { ZERO_AMOUNT } from "types/amount";
import { ISigningResponse } from "types/signing";
import { SigningComponent } from "../../signing/views/SigningComponent";
import { FormattedAmount } from "../../util/FormattedAmount";
import PinResetStore from "../stores/PinResetStore";

/**
 * Component for PinReset main screen
 */
@i18n.injectIntl
@inject("externalInterfaceStore")
@observer
export class PinResetSigning extends React.Component<RouteComponentProps<{}> & {
    pinResetStore: PinResetStore
}> {
    @observable isLoadingPin = false;

    onSigningSuccess = async (res: ISigningResponse) => {
        this.props.pinResetStore.signingResponse = res;

        // Not a captcha PIN -> need to get the PIN from the response ID
        try {
            this.isLoadingPin = true;
            await this.props.pinResetStore.getPin();
            pushRoute("/pin-reset/success");
        } catch (err) {
            debug.log("### getPin failed", err);
            pushRoute("/error");
        } finally {
            this.isLoadingPin = false;
        }
    }

    /**
     * Rendered if in state signing
     */
    render() {
        return (
            <SigningComponent
                signingInfo={this.props.pinResetStore.signInfo}

                content={
                    <pr.SigningLabelContainer>
                        <pr.SigningLabelSet>
                            <pr.SigningLabelTitle><i18n.FormattedMessage id="signing.action.label" /></pr.SigningLabelTitle>
                            <pr.SigningLabel><i18n.FormattedMessage id="pin.action.title" /></pr.SigningLabel>
                        </pr.SigningLabelSet>
                        <br />
                        <pr.SigningLabelSet>
                            <pr.SigningLabelTitle><i18n.FormattedMessage id="signing.card.label" /></pr.SigningLabelTitle>
                            <pr.SigningLabel>{this.props.pinResetStore.cardStore.card ? this.props.pinResetStore.cardStore.card.number : "-"}</pr.SigningLabel>
                            <pr.SigningLabel>{this.props.pinResetStore.cardStore.card ? this.props.pinResetStore.cardStore.card.sequenceNumber : "-"}</pr.SigningLabel>
                        </pr.SigningLabelSet>
                        <br />
                        <pr.SigningLabelSet>
                            <pr.SigningLabelTitle><i18n.FormattedMessage id="signing.fee.label" /></pr.SigningLabelTitle>
                            <FormattedAmount amount={this.props.pinResetStore.pinRestoreFee ? this.props.pinResetStore.pinRestoreFee : ZERO_AMOUNT} big />
                        </pr.SigningLabelSet>
                    </pr.SigningLabelContainer>
                }

                signInfoTac={ui.__("pin.signing.info.body.tac")}
                signInfoCardTan={ui.__("pin.signing.info.body.cardTan")}
                onSuccess={this.onSigningSuccess}
                onRetry={async () => { await this.props.pinResetStore.resetPin(); }}
                isLoading={this.isLoadingPin}
            />
        );
    }

}



// WEBPACK FOOTER //
// ./src/components/pin/views/PinResetSigning.tsx